<template>
  <div>
    <PageTitle
      title="Purchase Return View"
      :backBtn="true"
      :editRoute="'/purchase-return/edit/' + this.$route.params.id"
      :permission="'Purchase Return Edit'"
      :printvisible="true"
      @openPrintmethod="GotoPrintDetails"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xs="12">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title"
                  ><v-icon color="blue" small>mdi-sale</v-icon
                  ><span class="ml-3"> Purchase Details</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <v-icon>mdi-sale</v-icon>
                          {{
                            purchaseReturnViewModel.referencenumber
                              ? purchaseReturnViewModel.referencenumber
                              : '----'
                          }}
                        </v-col>

                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="text-center"
                        >
                          <span class="statustext pr-5">Status</span>
                          <v-chip
                            label
                            text-color="white"
                            style="
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            dark
                            :color="
                              getPurchaseOrderStatusColor(
                                purchaseReturnViewModel.status,
                              )
                            "
                          >
                            {{
                              purchaseReturnViewModel.status
                                ? purchaseReturnViewModel.status
                                : '----'
                            }}
                          </v-chip></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="textbold pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Supplier </v-row>
                          <v-row>
                            {{
                              purchaseReturnViewModel.suppliers.name
                                ? purchaseReturnViewModel.suppliers.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="textbold pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="textbold pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Warehouse </v-row>
                          <v-row>
                            {{ purchaseReturnViewModel.warehouses.name }}
                          </v-row>
                        </v-col>

                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="textbold pr-5 pt-0 mt-7"
                        >
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="textbold pr-5 pt-0 mt-5"
                        >
                          <v-row class="subtextlable"> Purchase Date </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{
                              purchaseReturnViewModel.date
                                ? purchaseReturnViewModel.date
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="d-flex justify-space-between"
              ><div>
                <v-icon small class="mb-1 mr-3" color="blue">
                  mdi-cash-refund </v-icon
                >Purchase Return Products
              </div>
            </v-card-title>
            <v-container fluid class="container saledetailscard">
              <PurchaseReturnTemplate
                id="qr-code"
                :datas="purchaseReturnViewModel"
                class="test1"
                :data="PurchasereturnItem"
                style="display: none"
              >
              </PurchaseReturnTemplate>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :headers="purchasereturnheaders"
                    :items="PurchasereturnItem"
                    disable-pagination
                    hide-default-footer
                  >
                    <template slot="body.footer">
                      <tr class="black--text">
                        <th class="title">Total</th>
                        <th class="title"></th>
                        <th class="title"></th>
                        <th class="title"></th>
                        <th class="title"></th>
                        <th class="title">
                          {{ purchaseReturnViewModel.total | formatCurrency }}
                        </th>
                      </tr>
                    </template>
                    <template v-slot:item.unitPrice="{ item }">
                      <div style="font-weight: bold">
                        {{ item.unitPrice | formatCurrency }}
                      </div>
                    </template>
                    <template v-slot:item.unit.name="{ item }">
                      <div style="font-weight: bold">
                        {{ item.unit.name ? item.unit.name : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.name="{ item }">
                      <div style="font-weight: bold">
                        {{ item.name ? item.name : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.selectedBatch.name="{ item }">
                      <div style="font-weight: bold">
                        {{
                          item.selectedBatch.name
                            ? item.selectedBatch.name
                            : '----'
                        }}
                      </div>
                    </template>
                    <template v-slot:item.quantity="{ item }">
                      <div style="font-weight: bold">
                        {{ item.quantity ? item.quantity : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.code="{ item }">
                      <div style="font-weight: bold">
                        {{ item.code ? item.code : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.total="{ item }">
                      <div style="font-weight: bold">
                        {{ (item.quantity * item.unitPrice) | formatCurrency }}
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row
                class="blue darken-1 white--text font-weight-black title mx-1"
              >
                <v-col cols="12" lg="12" sm="12" class="saletiltle text-right">
                  <strong class="mr-5">
                    Total Amount :
                    {{ purchaseReturnViewModel.total | formatCurrency }}
                  </strong>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-col></v-col>
          <v-card class="lighten-12">
            <v-card-title>Files</v-card-title>
            <v-container fluid class="container saledetailscard">
              <FileUpload
                :multiple="true"
                size="2048"
                icon="mdi-upload"
                autoupload="true"
                :url="'//' + this.$route.params.id"
                :showDocumentView="true"
                :documentsUrl="
                  'document/PURCHASE_RETURN/' + this.$route.params.id
                "
                downloadUrl="document/:id/download"
                removeUrl="document/:id"
              ></FileUpload>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <AuditLogs :Type="'purchase_return'" />
        </v-col>
      </v-row>

      <!-- Purchase return bill -->
      <purchaseReturnbill
        :PurchaseReturnDetails="purchaseReturnViewModel"
        :ProductData="PurchasereturnItem"
        :Suppliers="Supplier"
        ref="CallingBill"
        @closePreview="closePreview"
        v-show="false"
        :visible="purchaseReturnBillVisible"
      />
    </v-container>
  </div>
</template>

<script>
import purchaseReturnbill from '@/components/shared/PurchaseReturnBill.vue';
import FileUpload from '@/components/base/FileUpload';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import VueDocPreview from 'vue-doc-preview';
import { PurchaseReturnViewModel } from '../../../models/View Models/PurchaseReturn';
export default {
  data: () => ({
    selectedFiles: '',
    selectedProductsTotal: 0,
    purchaseReturnViewModel: new PurchaseReturnViewModel(),
    PurchasereturnItem: [],
    purchaseReturnBillVisible: false,
    purchasereturnheaders: [
      { text: 'Code', value: 'code', sortable: false, width: '20%' },
      { text: 'Name', value: 'name', sortable: false, width: '20%' },
      {
        text: 'Batches',
        value: 'selectedBatch.name',
        sortable: false,
        width: '20%',
      },
      { text: 'Qty', value: 'quantity', sortable: false, width: '10%' },
      {
        text: ' Unit ',
        value: 'unit.name',
        sortable: false,
        width: '10%',
      },
      {
        text: ' unitPrice ',
        value: 'unitPrice',
        width: '15%',
      },
      {
        text: 'Total',
        value: 'total',
        width: '15%',
        sortable: false,
      },
    ],
  }),
  methods: {
    closePreview() {
      this.purchaseReturnBillVisible = false;
    },
    GotoPrintDetails() {
      setTimeout(() => {
        this.purchaseReturnBillVisible = true;
      }, 100);
    },

    print() {
      this.$htmlToPaper('qr-code');
    },

    GetPurchaseReturn() {
      this.$store
        .dispatch('purchaseReturn/GetPurchaseReturn', this.$route.params.id)
        .then((res) => {
          this.purchaseReturnViewModel = new PurchaseReturnViewModel().set(
            res.data,
          );
          this.isLoading = false;
          this.PurchasereturnItem =
            this.purchaseReturnViewModel.selectedProducts;
          this.Supplier = this.purchaseReturnViewModel.suppliers;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.name;
          //  this.$toast.error("Registration Failed");
        });
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.GetPurchaseReturn();
  },
  components: {
    FileUpload,
    VueDocPreview,
    purchaseReturnbill,
  },
  computed: {
    printQr() {
      return {
        id: 'qr-code',
        popTitle: this.purchaseReturnViewModel.name,
      };
    },
  },
};
</script>

<style scoped>
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.totalText {
  font-family: Roboto;
  font-size: 16px;
}
</style>
